/* tslint:disable */
/* eslint-disable */

/**
 * 0 = DemandeTransport
 */
export enum TypeWebhook {
  DemandeTransport = 0
}
